import { render } from "./CompleteOrders.vue?vue&type=template&id=5d8d3c5e"
import script from "./CompleteOrders.vue?vue&type=script&lang=js"
export * from "./CompleteOrders.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/orders/CompleteOrders.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d8d3c5e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d8d3c5e', __exports__)) {
    console.log('reload')
    api.reload('5d8d3c5e', __exports__)
  }
  
  module.hot.accept("./CompleteOrders.vue?vue&type=template&id=5d8d3c5e", () => {
    console.log('re-render')
    api.rerender('5d8d3c5e', render)
  })

}


export default __exports__